import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNaviconCompaniesActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3018 10.6641C20.1071 11.6997 22.7759 14.4599 25.0819 15.5778",
			stroke: "#EAAFEF",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M25.4053 20.957L24.4053 18.957L21.4053 23.457V25.957V28.457L23.4053 26.957L25.4053 23.457V20.957Z",
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M13.9095 11.4047L15.7746 11.6741L12.4053 15.3964L10.4967 15.3961L8.40569 15.9564L9.27569 14.1848L11.8185 11.965L13.9095 11.4047Z",
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9039 22.413C10.7809 17.9122 13.3881 9.20864 24.8017 10.4003C26.4368 14.6945 25.6971 24.3675 14.954 25.8559",
			stroke: "#C948D8",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 19.1431,
			cy: 17.0087,
			r: 1.71273,
			transform: "rotate(71.6127 19.1431 17.0087)",
			stroke: "#EAAFEF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.202 18.872C25.6929 19.7331 26.6563 23.2898 22.8062 27.6311C22.067 28.4647 21.1026 28.4868 21.284 27.3875C21.3285 27.1175 21.386 26.7994 21.4585 26.4246C21.91 24.0888 20.9741 23.5987 20.7709 23.4356",
			stroke: "#C948D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.201 12.2142C15.2051 10.9963 11.8766 10.643 8.52796 14.6753C7.81612 15.5325 7.96523 16.4504 9.01883 16.0879C9.22745 16.0161 9.46519 15.9312 9.73622 15.8315C11.7945 15.0739 12.3794 15.8528 12.5579 16.0134",
			stroke: "#C948D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.4258 24.8147C10.4995 22.756 9.22614 25.7021 8.7037 27.9202C8.62549 28.2523 8.91048 28.548 9.24496 28.4808C11.4323 28.0413 14.348 26.869 12.4258 24.8147Z",
			stroke: "#EAAFEF"
		})
	]
});
export default SvgNaviconCompaniesActive;
